import React, { useLayoutEffect } from "react";
import AdminNavbar from "../../components/Navbars/AdminNavbar";
import Sidebar from "../../components/Sidebar/Sidebar";
import Home from "../../containers/HomePage/Home";
import FooterAdmin from "../../components/Footers/FooterAdmin";
import { Route, Switch, useHistory } from "react-router-dom";
import Dashboard from "../../views/admin/Dashboard";
import UserPage from "../../containers/UserPage";
import UserDetail from "../../containers/UserPage/UserDetail";
import AllUsers from "../../containers/UserPage/AllUsers";
import ProductPage from "../../containers/ProductPage";
import AllProduct from "../../containers/ProductPage/AllProduct";
import ProductDetail from "../../containers/ProductPage/ProductDetail";
import BlogPage from "../../containers/BlogPage";
import NewBlog from "../../containers/BlogPage/NewBlog";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile } from "actions/userActions";
import { RootState } from "store";

export default function Admin() {
	const dispatch = useDispatch();
	const history = useHistory();

	const { userInfo } = useSelector((state: RootState) => state.userInfo);

	useLayoutEffect(() => {
		if (!userInfo?.admin) {
			history.push("/");
		}
		dispatch(getUserProfile());
	}, []);
	return (
		<div className="relative h-full">
			<Sidebar />
			<div className="relative md:ml-64 bg-blueGray-100 py-32 px-14 bg-gradient-to-br from-sky-400 via-sky-500 to-sky-600 h-full">
				<AdminNavbar />
				<Switch>
					<Route path="/dashboard/insight" children={<Dashboard />} />
					<Route path="/dashboard/user/all" children={<AllUsers />} />
					<Route path="/dashboard/user/:id" children={<UserDetail />} />
					<Route path="/dashboard/user" children={<UserPage />} />
					<Route path="/dashboard/product/all" children={<AllProduct />} />
					<Route path="/dashboard/product/:id" children={<ProductDetail />} />
					<Route path="/dashboard/product" children={<ProductPage />} />
					<Route path="/dashboard/chat" children={<Dashboard />} />
					<Route path="/dashboard/blog/new" children={<NewBlog />} />
					<Route path="/dashboard/blog/:id" children={<NewBlog />} />
					<Route path="/dashboard/blog" children={<BlogPage />} />
					<Route exact path="/dashboard" children={<Home />} />
				</Switch>
				{/* Header */}
			</div>
			<div className="px-4 md:px-10 mx-auto w-full -m-24">
				<FooterAdmin />
			</div>
			<div className="fixed bg-white z-50 right-14 bottom-8 rounded-lg shadow-xl bg-opacity-50 border-2 border-sky-500 font-bold">
				<select className="border-0 focus:outline-none focus:border-0 py-1 px-2 rounded-lg pr-8 bg-opacity-40">
					<option>day</option>
					<option>week</option>
					<option>month</option>
				</select>
			</div>
		</div>
	);
}
